import React from 'react';

const SiteBlock = ({
  cols,
  color,
  title,
  pvalue,
  ptype,
  pvalue_hist,
  phist_text,
  pvalueOut,
  ptypeOut,
  pvalue_histOut,
  phist_textOut,
}) => (
  <table className="tbl text-center">
    <thead>
      <th
        colSpan={cols}
        style={{
          textAlign: 'center',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          backgroundColor: color,
        }}
      >
        {title}
      </th>
    </thead>
    <tbody>
      <td>
        {pvalue}
        <br />
        {ptype}
        <hr />
        {pvalue_hist}
        <br />
        {phist_text}
      </td>
      {cols === 2 ? (
        <td>
          {pvalueOut}
          <br />
          {ptypeOut}
          <hr />
          {pvalue_histOut}
          <br />
          {phist_textOut}
        </td>
      ) : (
        ''
      )}
    </tbody>
  </table>
);

export default SiteBlock;
